import React from 'react'

export default function CommonSlider({ sliderData }) {
    if (!sliderData) return null;

    return (
        <div className="resorts-box p-3 bg-white">
            <figure>
                <img
                    src={sliderData.image_url}
                    alt={sliderData.name}
                    className="img-fluid"
                />
            </figure>

            <div className="resorts-content-box">
                <div className="d-flex justify-content-between">
                    <span className="rating-star">
                        <i className="fa-solid fa-star"></i>
                        {sliderData.rating} Overall Reviews
                    </span>
                </div>

                <div className="resort-description border-0 m-0">
                    <h3>{sliderData.name}</h3>
                </div>

                <div className="book-trip-btn">
                    <a
                        href={sliderData.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-100 text-center d-block"
                    >
                        Order Now
                    </a>
                </div>
            </div>
        </div>
    );
}
